import { PERMISSIONS } from '~/constants'

export default (): string => {
  if (useHasPermissions([PERMISSIONS.CAN_VIEW_PROPERTIES])) return '/properties/all'
  if (useHasPermissions([PERMISSIONS.CAN_VIEW_EXCLUSIVE_UNITS])) return '/properties/exclusives'
  if (useHasPermissions([PERMISSIONS.CAN_VIEW_DICTIONARIES])) return '/properties/dictionaries/developers'
  if (useHasPermissions([PERMISSIONS.CAN_VIEW_INTERNAL_PROJECTS])) return '/properties/internal-projects'
  if (useHasPermissions([PERMISSIONS.CAN_MANAGE_USERS])) return '/admin-settings/users'
  if (useHasPermissions([PERMISSIONS.CAN_MANAGE_ROLES])) return '/admin-settings/permissions'
  if (useHasPermissions([PERMISSIONS.CAN_MANAGE_PROPERTIES])) return '/admin-settings/tags'
  if (useHasPermissions([PERMISSIONS.CAN_MANAGE_EXCLUSIVE_UNITS])) return '/admin-settings/unit-settings'
  return '/content-management/news-feed'
}
